import React from "react"
import IconButton from "@mui/material/IconButton"
import ClearButton from "@mui/icons-material/Clear"

const CloseBurgerMenu = (props) => {
  return (
    <IconButton aria-label="clear" size="small" {...props}>
      <ClearButton />
    </IconButton>
  )
}

export default CloseBurgerMenu
